import { render, staticRenderFns } from "./global-depot-select.vue?vue&type=template&id=0f90be84&"
import script from "./global-depot-select.vue?vue&type=script&lang=js&"
export * from "./global-depot-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports